import React from 'react';

const About = () => {
    return (
        <div className='text-center '>
            <h2>My Name: Sohana Nazneen</h2>
            <p>My goal is to became a full stack developer</p>
            <p>I want to earn halal income </p>
            <p>I'm trying my best to do better in this field and become a good programmer</p>
            <p>To pursue a highly rewarding career, seeking for a job in challenging and healthy work environment where i can utilize my skills. </p>
            <p> My Dream is to became a computer engineer.</p>
        </div>
    );
};

export default About;